import { isEnglishLocale } from './locale';

const normalizeLabel = (value = '') => String(value || '').trim();

export const getIconFallbackLabel = (locale, kind, label = '') => {
  const isEn = isEnglishLocale(locale);
  const resolvedLabel = normalizeLabel(label);

  switch (kind) {
    case 'section':
      return isEn ? 'Section icon' : 'Icono de seccion';
    case 'list':
      return isEn ? 'List icon' : 'Icono de lista';
    case 'feature':
      return resolvedLabel || (isEn ? 'Feature icon' : 'Icono de caracteristica');
    case 'location':
      return resolvedLabel || (isEn ? 'Location icon' : 'Icono de ubicacion');
    case 'typology':
      return resolvedLabel || (isEn ? 'Typology icon' : 'Icono de tipologia');
    case 'button':
      if (resolvedLabel) {
        return isEn ? `Icon for ${resolvedLabel}` : `Icono de ${resolvedLabel}`;
      }
      return isEn ? 'Button icon' : 'Icono de boton';
    default:
      if (resolvedLabel) {
        return isEn ? `Icon for ${resolvedLabel}` : `Icono de ${resolvedLabel}`;
      }
      return isEn ? 'Icon' : 'Icono';
  }
};

export const getContactTypeLabel = (locale, type) => {
  const isEn = isEnglishLocale(locale);

  switch (type) {
    case 'formulario':
      return isEn ? 'Form' : 'Formulario';
    case 'whatsapp':
      return 'WhatsApp';
    case 'phone':
      return isEn ? 'Phone' : 'Telefono';
    case 'email':
      return isEn ? 'Email' : 'Correo';
    case 'address':
      return isEn ? 'Address' : 'Direccion';
    default:
      return '';
  }
};

export const getUiText = (locale, key, options = {}) => {
  const isEn = isEnglishLocale(locale);
  const label = normalizeLabel(options.label);
  const index = Number(options.index);

  switch (key) {
    case 'whatsappSaved':
      return isEn ? 'Thank you. Your details have been saved. You can now continue to WhatsApp.' : 'Gracias. Tus datos se guardaron. Ya puedes continuar a WhatsApp.';
    case 'whatsappContinue':
      return isEn ? 'Continue to WhatsApp' : 'Continuar a WhatsApp';
    case 'whatsappPopupBlocked':
      return isEn ? 'Allow pop-ups to open WhatsApp, then try again.' : 'Permite las ventanas emergentes para abrir WhatsApp e inténtalo de nuevo.';
    case 'whatsappWindowClosed':
      return isEn ? 'Your details were saved. Open WhatsApp to continue.' : 'Tus datos se guardaron. Abre WhatsApp para continuar.';
    case 'whatsappSaveError':
      return isEn ? 'We could not save your details. Please try again.' : 'No pudimos guardar tus datos. Inténtalo de nuevo.';
    case 'whatsappGreeting':
      return isEn ? 'Hi, I am' : 'Hola, soy';
    case 'whatsappInterest':
      return isEn ? 'I would like information about Vesta Park Santa Barbara.' : 'Quiero información sobre Vesta Park Santa Barbara.';
    case 'whatsappHeading':
      return isEn ? 'Contact us on WhatsApp' : 'Contáctanos por WhatsApp';
    case 'whatsappIntro':
      return isEn ? 'Leave your details and we will help you shortly.' : 'Déjanos tus datos y te atenderemos enseguida.';
    case 'whatsappFullName':
      return isEn ? 'Full Name' : 'Nombre Completo';
    case 'whatsappNamePlaceholder':
      return isEn ? 'E.g. John Smith' : 'Ej: Juan Pérez García';
    case 'whatsappEmail':
      return isEn ? 'Email Address' : 'Correo Electrónico';
    case 'whatsappEmailPlaceholder':
      return isEn ? 'your.email@example.com' : 'tu.email@ejemplo.com';
    case 'whatsappPhone':
      return isEn ? 'Phone Number' : 'Número de Teléfono';
    case 'whatsappCountryCode':
      return isEn ? 'Country calling code' : 'Código telefónico del país';
    case 'whatsappSend':
      return isEn ? 'Send message' : 'Enviar mensaje';
    case 'whatsappPrivacy':
      return isEn ? 'Your data is protected and will not be shared with third parties.' : 'Tus datos están protegidos y no serán compartidos con terceros.';
    case 'whatsappChatInterest':
      return isEn ? 'I would like more information about Vesta Park Santa Barbara. Contact from the chatbot.' : 'Me interesa recibir información sobre Vesta Park Santa Barbara. Contacto desde el chatbot.';
    case 'whatsappOpen':
      return isEn ? 'Open WhatsApp' : 'Abrir WhatsApp';
    case 'goHome':
      return isEn ? 'Go to home' : 'Ir a inicio';
    case 'scrollTop':
      return isEn ? 'Back to top' : 'Volver arriba';
    case 'openMenu':
      return isEn ? 'Open menu' : 'Abrir menu';
    case 'closeMenu':
      return isEn ? 'Close menu' : 'Cerrar menu';
    case 'contact':
      return isEn ? 'Commercial Contact' : 'Contacto';
    case 'links':
      return isEn ? 'Links' : 'Enlaces';
    case 'submit':
      return isEn ? 'Submit' : 'Enviar';
    case 'accept':
      return isEn ? 'Accept' : 'Aceptar';
    case 'sending':
      return isEn ? 'Sending...' : 'Enviando...';
    case 'cookiesTitle':
      return isEn ? 'We value your privacy' : 'Valoramos tu privacidad';
    case 'cookiesBody':
      return isEn
        ? 'This website stores cookies on your devices. They are used to collect information about how you interact with our website and improve your browsing experience. For more information about the cookies we use, please see our Privacy Policy.'
        : 'Este sitio web almacena cookies en tus dispositivos. Son utilizadas para recopilar informacion acerca de la forma en que interactuas con nuestro sitio web y mejorar tu experiencia de navegacion. Para obtener mas informacion sobre las cookies que utilizamos, consulta nuestra Politica de privacidad.';
    case 'imageIndex':
      return isEn ? `Go to image ${index}` : `Ir a imagen ${index}`;
    case 'expandedImage':
      return isEn ? 'Expanded image' : 'Imagen ampliada';
    case 'maximize':
      return isEn ? 'Maximize' : 'Maximizar';
    case 'close':
      return isEn ? 'Close' : 'Cerrar';
    case 'previous':
      return isEn ? 'Previous' : 'Anterior';
    case 'next':
      return isEn ? 'Next' : 'Siguiente';
    case 'previousImage':
      return isEn ? 'Previous image' : 'Imagen anterior';
    case 'nextImage':
      return isEn ? 'Next image' : 'Siguiente imagen';
    case 'typologyNavigation':
      return isEn ? 'Typology navigation' : 'Navegacion de tipologias';
    case 'goToTypology':
      return isEn ? `Go to typology ${index}` : `Ir a tipologia ${index}`;
    case 'previousTypology':
      return isEn ? 'Previous typology' : 'Tipologia anterior';
    case 'nextTypology':
      return isEn ? 'Next typology' : 'Siguiente tipologia';
    case 'floorplan':
      return isEn ? 'Floorplan' : 'Plano';
    case 'imageLabel':
      return isEn ? `Image ${index}` : `Imagen ${index}`;
    case 'expandFloorplan':
      return isEn ? 'Expand floorplan' : 'Ampliar floorplan';
    case 'expandedFloorplan':
      return label || (isEn ? 'Expanded floorplan' : 'Floorplan ampliado');
    case 'closeExpandedFloorplan':
      return isEn ? 'Close expanded floorplan' : 'Cerrar floorplan ampliado';
    case 'popupFullscreen':
      return isEn ? 'Fullscreen popup' : 'Popup fullscreen';
    case 'closeFullscreenPopup':
      return isEn ? 'Close fullscreen popup' : 'Cerrar popup fullscreen';
    case 'playVideo':
      return isEn ? 'Play video' : 'Reproducir video';
    case 'pauseVideo':
      return isEn ? 'Pause video' : 'Pausar video';
    case 'unmuteAudio':
      return isEn ? 'Unmute audio' : 'Activar audio';
    case 'muteAudio':
      return isEn ? 'Mute audio' : 'Silenciar audio';
    case 'poster':
      if (label) {
        return isEn ? `Poster of ${label}` : `Poster de ${label}`;
      }
      return 'Poster';
    default:
      return label;
  }
};